import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const Dashboard = () => {
  const [period, setPeriod] = useState('7days');
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
    shippingOrders: 0,
    deliveredOrders: 0,
    todayRevenue: 0,
    monthRevenue: 0,
    totalCustomers: 0,
    totalProducts: 0,
    lowStockProducts: 0,
    outOfStockProducts: 0
  });

  const [salesData, setSalesData] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [orderStatusData, setOrderStatusData] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);
  const [recentCustomers, setRecentCustomers] = useState([]);
  const [recentDeliveries, setRecentDeliveries] = useState([]);
  const [notifications, setNotifications] = useState([]);

  // Icônes SVG
  const Icons = {
    Package: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    Clock: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    Truck: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 17h2M19 17h2M12 21v-4M8 3h8M12 3v2" />
      </svg>
    ),
    CheckCircle: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    TrendingUp: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
    ChartBar: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    Users: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    ShoppingBag: () => (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
    ),
    Bell: () => (
      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    ),
    ExternalLink: () => (
      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
      </svg>
    )
  };

  // Charger les données du backend
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        const statsRes = await api.get('/admin/stats');
        setStats(statsRes.data);
        
        const ordersRes = await api.get('/admin/orders', { params: { limit: 5 } });
        // ✅ Vérification que ordersRes.data.orders est un tableau
        setRecentOrders(Array.isArray(ordersRes.data.orders) ? ordersRes.data.orders : []);
        
        const productsRes = await api.get('/admin/products');
        // ✅ Vérification que productsRes.data est un tableau
        const productsData = Array.isArray(productsRes.data) ? productsRes.data : [];
        
        // ✅ Vérification que le tableau n'est pas vide avant de faire sort
        let sortedProducts = [];
        if (productsData.length > 0) {
          sortedProducts = [...productsData]
            .sort((a, b) => (b.stock || 0) - (a.stock || 0))
            .slice(0, 5);
        }
        
        setTopProducts(sortedProducts.map(p => ({
          name: p.name || 'Produit sans nom',
          sales: p.stock || 0,
          revenue: (p.price || 0) * (p.stock || 0),
          stock: p.stock || 0
        })));
        
        const usersRes = await api.get('/admin/users');
        // ✅ Vérification que usersRes.data est un tableau
        setRecentCustomers(Array.isArray(usersRes.data) ? usersRes.data.slice(0, 4) : []);
        
        const deliveriesRes = await api.get('/admin/deliveries', { params: { limit: 3 } });
        // ✅ Vérification que deliveriesRes.data est un tableau
        setRecentDeliveries(Array.isArray(deliveriesRes.data) ? deliveriesRes.data.slice(0, 3) : []);
        
        // ✅ Générer les données de ventes (mock)
        if (period === '7days') {
          setSalesData([
            { name: 'Lun', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Mar', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Mer', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Jeu', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Ven', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Sam', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 },
            { name: 'Dim', ventes: Math.floor(Math.random() * 500) + 200, commandes: Math.floor(Math.random() * 20) + 5 }
          ]);
        }
        
        setOrderStatusData([
          { name: 'En attente', value: statsRes.data.pendingOrders || 0, color: '#F59E0B' },
          { name: 'En livraison', value: statsRes.data.shippingOrders || 0, color: '#3B82F6' },
          { name: 'Livrees', value: statsRes.data.deliveredOrders || 0, color: '#10B981' }
        ]);
        
        setNotifications([
          { id: 1, type: 'order', message: 'Nouvelle commande', time: 'Il y a 5 min', read: false },
          { id: 2, type: 'payment', message: 'Paiement reçu', time: 'Il y a 15 min', read: false },
          { id: 3, type: 'stock', message: 'Stock faible sur un produit', time: 'Il y a 1 heure', read: false }
        ]);
        
      } catch (error) {
        console.error('Erreur chargement dashboard:', error);
        // ✅ En cas d'erreur, on met des valeurs par défaut
        setRecentOrders([]);
        setTopProducts([]);
        setRecentCustomers([]);
        setRecentDeliveries([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchDashboardData();
  }, [period]);

  const statCards = [
    { title: 'Total commandes', value: stats.totalOrders, icon: <Icons.Package />, color: 'bg-blue-500', link: '/admin/orders' },
    { title: 'En attente', value: stats.pendingOrders, icon: <Icons.Clock />, color: 'bg-yellow-500', link: '/admin/orders?status=pending' },
    { title: 'En livraison', value: stats.shippingOrders, icon: <Icons.Truck />, color: 'bg-orange-500', link: '/admin/orders?status=shipped' },
    { title: 'Livrees', value: stats.deliveredOrders, icon: <Icons.CheckCircle />, color: 'bg-green-500', link: '/admin/orders?status=delivered' },
    { title: 'CA aujourd\'hui', value: stats.todayRevenue ? stats.todayRevenue.toFixed(2) + ' €' : '0 €', icon: <Icons.TrendingUp />, color: 'bg-emerald-500', link: '/admin/reports' },
    { title: 'CA du mois', value: stats.monthRevenue ? stats.monthRevenue.toFixed(2) + ' €' : '0 €', icon: <Icons.ChartBar />, color: 'bg-purple-500', link: '/admin/reports' },
    { title: 'Clients', value: stats.totalCustomers, icon: <Icons.Users />, color: 'bg-indigo-500', link: '/admin/users' },
    { title: 'Produits', value: stats.totalProducts, icon: <Icons.ShoppingBag />, color: 'bg-pink-500', link: '/admin/products' }
  ];

  const getStatusBadge = (status) => {
    const badges = {
      pending: 'bg-yellow-100 text-yellow-600',
      shipped: 'bg-blue-100 text-blue-600',
      delivered: 'bg-green-100 text-green-600',
      preparing: 'bg-purple-100 text-purple-600',
      confirmed: 'bg-indigo-100 text-indigo-600',
      cancelled: 'bg-red-100 text-red-600'
    };
    const labels = {
      pending: 'En attente',
      shipped: 'En livraison',
      delivered: 'Livree',
      preparing: 'Preparation',
      confirmed: 'Confirmee',
      cancelled: 'Annulee'
    };
    return <span className={'px-2 py-1 rounded-full text-xs ' + (badges[status] || 'bg-gray-100 text-gray-600')}>{labels[status] || status}</span>;
  };

  const getDeliveryStatusBadge = (status) => {
    if (status === 'delivered') return <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-600">Livree</span>;
    if (status === 'in_progress') return <span className="px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-600">En cours</span>;
    if (status === 'failed') return <span className="px-2 py-1 rounded-full text-xs bg-red-100 text-red-600">Echec</span>;
    return <span className="px-2 py-1 rounded-full text-xs bg-yellow-100 text-yellow-600">En attente</span>;
  };

  const openShop = () => {
    window.open('/', '_blank');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-500 text-sm sm:text-base">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4 md:p-6">
      {/* En-tête avec bouton Voir la boutique - Responsive */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4 sm:mb-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold">Tableau de bord</h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-0.5 sm:mt-1">Bienvenue dans votre espace d'administration</p>
        </div>
        <button 
          onClick={openShop}
          className="bg-secondary text-primary px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-opacity-90 transition flex items-center gap-2 font-semibold shadow-md hover:shadow-lg text-sm sm:text-base w-full sm:w-auto justify-center"
        >
          <Icons.ExternalLink />
          Voir la boutique
        </button>
      </div>

      {/* Notifications - Responsive */}
      <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 mb-4 sm:mb-6">
        <div className="flex items-center justify-between">
          <h2 className="font-bold text-sm sm:text-lg flex items-center gap-2">
            <Icons.Bell /> Notifications
          </h2>
          <span className="text-xs sm:text-sm text-gray-500">{notifications.filter(n => !n.read).length} non lues</span>
        </div>
        <div className="mt-2 sm:mt-3 space-y-1.5 sm:space-y-2">
          {notifications.map(notif => (
            <div key={notif.id} className={'flex items-center gap-2 sm:gap-3 p-1.5 sm:p-2 rounded-lg text-xs sm:text-sm ' + (!notif.read ? 'bg-blue-50' : '')}>
              <div className={'w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full ' + (!notif.read ? 'bg-blue-500' : 'bg-gray-300')}></div>
              <span className="text-xs sm:text-sm flex-1">{notif.message}</span>
              <span className="text-[10px] sm:text-xs text-gray-400">{notif.time}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Stats Cards - Responsive */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 md:gap-4 mb-4 sm:mb-6">
        {statCards.map((card, idx) => (
          <Link key={idx} to={card.link} className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5 hover:shadow-lg transition border-l-4 border-l-secondary">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 text-[10px] sm:text-sm">{card.title}</p>
                <p className="text-base sm:text-xl md:text-2xl font-bold mt-0.5 sm:mt-1">{card.value}</p>
              </div>
              <div className={card.color + ' text-white p-1.5 sm:p-2.5 md:p-3 rounded-full'}>
                <span className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center">
                  {card.icon}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Alertes stock - Responsive */}
      {(stats.lowStockProducts > 0 || stats.outOfStockProducts > 0) && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-3 sm:p-4 mb-4 sm:mb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4">
          <div>
            <span className="text-red-600 font-semibold flex items-center gap-2 text-sm sm:text-base">
              <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              Alertes stock
            </span>
            <p className="text-xs sm:text-sm text-red-500 mt-0.5 sm:mt-1">{stats.lowStockProducts} produit(s) en stock faible • {stats.outOfStockProducts} produit(s) en rupture</p>
          </div>
          <Link to="/admin/products" className="text-red-600 text-xs sm:text-sm hover:underline whitespace-nowrap">Voir les produits →</Link>
        </div>
      )}

      {/* Graphiques - Responsive */}
      <div className="grid lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-3 sm:mb-4">
            <h2 className="font-bold text-sm sm:text-lg flex items-center gap-2">
              <Icons.TrendingUp /> Evolution des ventes
            </h2>
            <div className="flex gap-1 sm:gap-2">
              <button onClick={() => setPeriod('7days')} className={'px-2 py-1 text-[10px] sm:text-sm rounded ' + (period === '7days' ? 'bg-primary text-white' : 'bg-gray-100')}>7j</button>
              <button onClick={() => setPeriod('30days')} className={'px-2 py-1 text-[10px] sm:text-sm rounded ' + (period === '30days' ? 'bg-primary text-white' : 'bg-gray-100')}>30j</button>
              <button onClick={() => setPeriod('12months')} className={'px-2 py-1 text-[10px] sm:text-sm rounded ' + (period === '12months' ? 'bg-primary text-white' : 'bg-gray-100')}>12m</button>
            </div>
          </div>
          <div className="space-y-1.5 sm:space-y-2 max-h-60 sm:max-h-80 overflow-y-auto">
            {salesData.map((item, idx) => (
              <div key={idx} className="flex justify-between items-center p-1.5 sm:p-2 border-b text-xs sm:text-sm">
                <span className="font-medium text-xs sm:text-sm">{item.name}</span>
                <div className="flex gap-2 sm:gap-4"><span>{item.ventes} €</span><span className="text-gray-500 text-xs sm:text-sm">{item.commandes} cmd</span></div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <h2 className="font-bold text-sm sm:text-lg mb-3 sm:mb-4 flex items-center gap-2">
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            </svg>
            Produits les plus vendus
          </h2>
          <div className="space-y-2 sm:space-y-3">
            {topProducts.map((product, idx) => (
              <div key={idx} className="flex items-center gap-2 sm:gap-3">
                <div className="w-5 h-5 sm:w-8 sm:h-8 text-center font-bold text-secondary text-xs sm:text-base flex items-center justify-center">{idx+1}</div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row justify-between mb-0.5 sm:mb-1">
                    <span className="font-medium text-xs sm:text-sm">{product.name}</span>
                    <span className="text-[10px] sm:text-sm">{product.sales} vendus</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1.5 sm:h-2">
                    <div className="bg-secondary h-1.5 sm:h-2 rounded-full" style={{ width: (product.sales / (topProducts[0]?.sales || 1)) * 100 + '%' }}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Commandes + Repartition - Responsive */}
      <div className="grid lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <h2 className="font-bold text-sm sm:text-lg mb-3 sm:mb-4 flex items-center gap-2">
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            Repartition des commandes
          </h2>
          <div className="space-y-2 sm:space-y-3">
            {orderStatusData.map((item, idx) => (
              <div key={idx} className="flex items-center justify-between p-2 sm:p-3 bg-gray-50 rounded-lg text-sm sm:text-base">
                <div className="flex items-center gap-2"><div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full" style={{ backgroundColor: item.color }}></div><span className="text-xs sm:text-sm">{item.name}</span></div>
                <span className="font-bold text-sm sm:text-lg">{item.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <h2 className="font-bold text-sm sm:text-lg mb-3 sm:mb-4 flex items-center gap-2">
            <Icons.ShoppingBag /> Dernieres commandes
          </h2>
          <div className="space-y-2 sm:space-y-3">
            {recentOrders.slice(0, 5).map(order => (
              <div key={order.id} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-2 border-b gap-1 sm:gap-2">
                <div>
                  <p className="font-medium text-xs sm:text-sm">{order.order_number}</p>
                  <p className="text-[10px] sm:text-xs text-gray-500">{order.customer_name}</p>
                </div>
                <div className="flex items-center gap-2 sm:gap-3">
                  <p className="font-bold text-xs sm:text-sm">{order.grand_total} €</p>
                  {getStatusBadge(order.status)}
                </div>
              </div>
            ))}
          </div>
          <Link to="/admin/orders" className="block text-center text-secondary text-xs sm:text-sm mt-3 hover:underline">Voir toutes les commandes →</Link>
        </div>
      </div>

      {/* Clients + Livraisons - Responsive */}
      <div className="grid lg:grid-cols-2 gap-4 sm:gap-6">
        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <h2 className="font-bold text-sm sm:text-lg mb-3 sm:mb-4 flex items-center gap-2">
            <Icons.Users /> Derniers clients inscrits
          </h2>
          <div className="space-y-2 sm:space-y-3">
            {recentCustomers.map(customer => (
              <div key={customer.id} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-2 border-b gap-1 sm:gap-2">
                <div>
                  <p className="font-medium text-xs sm:text-sm">{customer.first_name} {customer.last_name}</p>
                  <p className="text-[10px] sm:text-xs text-gray-500">{customer.email}</p>
                </div>
                <div className="text-right">
                  <p className="text-[10px] sm:text-xs text-gray-500">{new Date(customer.created_at).toLocaleDateString()}</p>
                </div>
              </div>
            ))}
          </div>
          <Link to="/admin/users" className="block text-center text-secondary text-xs sm:text-sm mt-3 hover:underline">Voir tous les clients →</Link>
        </div>

        <div className="bg-white rounded-xl shadow-md p-3 sm:p-4 md:p-5">
          <h2 className="font-bold text-sm sm:text-lg mb-3 sm:mb-4 flex items-center gap-2">
            <Icons.Truck /> Dernieres livraisons
          </h2>
          <div className="space-y-2 sm:space-y-3">
            {recentDeliveries.map(delivery => (
              <div key={delivery.id} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-2 border-b gap-1 sm:gap-2">
                <div>
                  <p className="font-medium text-xs sm:text-sm">{delivery.order_number}</p>
                  <p className="text-[10px] sm:text-xs text-gray-500">{delivery.customer_name}</p>
                  <p className="text-[10px] sm:text-xs text-gray-400">{delivery.delivery_address}</p>
                </div>
                <div className="text-right">
                  {getDeliveryStatusBadge(delivery.status)}
                  <p className="text-[10px] sm:text-xs text-gray-400 mt-0.5 sm:mt-1">{delivery.estimated_time || 'A venir'}</p>
                </div>
              </div>
            ))}
          </div>
          <Link to="/admin/delivery" className="block text-center text-secondary text-xs sm:text-sm mt-3 hover:underline">Gerer les livraisons →</Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;